var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"content-list"},_vm._l((_vm.contents),function(content){return _c('li',{class:`${_vm.current === content.path ? 'current':''}`},[_c('a',{attrs:{"href":`#/${content.path}`}}),_vm._v(" "+_vm._s(content.title)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }